import { useState } from "react";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import cn from "classnames";
import { useAppDispatch } from "../../../store/hooks";
import { addServiceData } from "../../../store/ses/sesRobotSlice";
import useTranslate from "../../../hooks/useTranslate";
import { ROBOT_SERVICE_TYPE_EXTENDED_LIST, ServiceTypeRobotExtended } from "../../../constants/robotConfigLists";
import { colorPrimary } from "../../../constants/colors";
import { ServiceTypeRobot } from "../../../types/cloudTypes";
import { IFormAddingServiceDataProps } from "./FormAddingServiceData.props";
import styles from "./FormAddingServiceData.module.scss";

const FormAddingServiceData = ({ serviceDataName, changeFlgHandler }: IFormAddingServiceDataProps): JSX.Element => {
	const [selectType, _setSelectType] = useState<ServiceTypeRobotExtended>("chooseType"); // тип

	const dispatch = useAppDispatch();

	const translate = useTranslate(); // hook для перевода текста

	// обработчик добавления сервисных данных
	const addServiceDataHandler = (e: SelectChangeEvent<ServiceTypeRobotExtended>): void => {
		const value = e.target.value as ServiceTypeRobot;
		dispatch(addServiceData({ serviceDataName, type: value }));
		changeFlgHandler("servicedata"); // ставим флаг о несохраненных данных
	};

	return (
		<div
			className={cn(styles.container, {
				[styles.containerOpacity]: selectType === "chooseType",
			})}
		>
			{/* тип */}
			<FormControl fullWidth sx={{ '.MuiInputLabel-root[data-shrink="false"]': { top: -8 } }}>
				<InputLabel sx={{ fontSize: 13 }}>{translate("select_type")}</InputLabel>
				<Select
					label={translate("select_type")}
					value={selectType}
					onChange={addServiceDataHandler}
					style={{ fontSize: 13, height: 33, color: colorPrimary, textAlign: "left" }}
				>
					{ROBOT_SERVICE_TYPE_EXTENDED_LIST.map(({ type, translation }) => (
						<MenuItem key={type} value={type} sx={{ fontSize: 13, color: colorPrimary }} disabled={type === "chooseType"}>
							{translate(translation)}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};

export default FormAddingServiceData;
